import request from '../utils/request'
//补充证据
export function adminicleDetails(case_id) {
    return request.post('/api/zhcai_case_evidence_detail',{"case_id":case_id})
}
//保存
export function evidencePreserve(case_id,evidence_data) {
    return request.post('/api/zhcai_case_save_evidence',{"case_id":case_id,"evidence_data":evidence_data})
}
//上传
export function uploadFile(case_id,evidence_id,file,is_main) {
    return request.post('/api/upload_zhcai_evidence_file',{"case_id":case_id,"evidence_id":evidence_id,"file":file,"is_main":is_main})
}
